import React, { useEffect } from 'react';

const TitleBlockView = ({ properties, metadata, data }) => {

/*   useEffect(() => (
    console.log("A")
  ), [data.showRightDesignElem, data.showLeftDesignElem])
 */
  const leftDesignElem = (
    <div className='leftDesign'>
      <svg width="620" xmlns="http://www.w3.org/2000/svg" height="15" fill="none">
        <path d="M0 7.5H600" className="fills" />
        <g className="strokes">
          <path
            d="M0 7.5H600"
            style={{
              fill: 'none',
              strokeWidth: 5,
              stroke: 'rgb(255, 255, 255)',
              strokeOpacity: 1,
              strokeDasharray: '0, 10',
              strokeLinecap: 'round',
            }}
            className="stroke-shape"
          />
        </g>
        <path
          d="M607.071 0c4.14 0 7.5 3.361 7.5 7.5 0 4.139-3.36 7.5-7.5 7.5a7.504 7.504 0 0 1-7.5-7.5c0-4.139 3.361-7.5 7.5-7.5Zm0 3a4.502 4.502 0 0 0-4.5 4.5c0 2.484 2.017 4.5 4.5 4.5 2.484 0 4.5-2.016 4.5-4.5s-2.016-4.5-4.5-4.5Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            fillOpacity: 1,
          }}
          className="fills"
        />
        <g className="strokes">
          <path
            d="M607.071 0c4.14 0 7.5 3.361 7.5 7.5 0 4.139-3.36 7.5-7.5 7.5a7.504 7.504 0 0 1-7.5-7.5c0-4.139 3.361-7.5 7.5-7.5Zm0 3a4.502 4.502 0 0 0-4.5 4.5c0 2.484 2.017 4.5 4.5 4.5 2.484 0 4.5-2.016 4.5-4.5s-2.016-4.5-4.5-4.5Z"
            style={{
              fill: 'none',
              strokeWidth: 1,
              stroke: 'rgb(255, 255, 255)',
              strokeOpacity: 1,
            }}
            className="stroke-shape"
          />
        </g>
      </svg>
    </div>
  );

  const rightDesignElem = (
    <div className='rightDesign'>
      <svg width="1000" xmlns="http://www.w3.org/2000/svg" height="15" fill="none">
        <path d="M21.5 7.432h978.5" className="fills" />
        <g className="strokes">
          <path d="M21.5 7.432h978.5" style={{ fill: 'none', strokeWidth: 5, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1, strokeDasharray: '0, 10', strokeLinecap: 'round' }} className="stroke-shape" />
        </g>
        <path d="M7.5 0C11.639 0 15 3.361 15 7.5c0 4.139-3.361 7.5-7.5 7.5A7.504 7.504 0 0 1 0 7.5C0 3.361 3.361 0 7.5 0Zm0 3A4.502 4.502 0 0 0 3 7.5C3 9.984 5.016 12 7.5 12S12 9.984 12 7.5 9.984 3 7.5 3Z" style={{ fill: 'rgb(255, 255, 255)', fillOpacity: 1 }} className="fills" />
        <g className="strokes">
          <path d="M7.5 0C11.639 0 15 3.361 15 7.5c0 4.139-3.361 7.5-7.5 7.5A7.504 7.504 0 0 1 0 7.5C0 3.361 3.361 0 7.5 0Zm0 3A4.502 4.502 0 0 0 3 7.5C3 9.984 5.016 12 7.5 12S12 9.984 12 7.5 9.984 3 7.5 3Z" style={{ fill: 'none', strokeWidth: 1, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1 }} className="stroke-shape" />
        </g>
      </svg>
    </div>
  )


  return (

      <div className="full-width highlight-title">
        <h1 className="documentFirstHeading">
          {(metadata || properties)['title'] || ''}
          {leftDesignElem}

        </h1>
        {data.showRightDesignElem && rightDesignElem}
      </div>

  );
};

export default TitleBlockView;
